import { Reveal } from "./primitives";
import { CtaButton, TrustRow } from "./Cta";

export const FinalCta = () => (
  <section className="relative overflow-hidden bg-[#0A111E]">
    <div className="absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-amber-500/10 blur-[130px]" />
    <div className="relative mx-auto max-w-4xl px-6 py-24 text-center sm:py-32">
      <Reveal>
        <span className="font-tech text-xs tracking-[0.4em] text-cyan-400">
          ABSORBANCIA PERFECTA
        </span>
        <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">
          Sí, quiero dominar el <span className="text-cyan-300">Mindray BA-88A</span> ahora
        </h2>
        <div className="mt-10">
          <CtaButton testId="final-cta-button">
            Sí, quiero dominar el Mindray BA-88A ahora
          </CtaButton>
          <TrustRow className="mt-8 justify-center" />
        </div>
      </Reveal>
    </div>
  </section>
);
